import Mapping from '../lang/index';

export default (lang = 'fr') => {
    // default is fr
    // return Mapping[lang];
    return Mapping['fr'];
};

const prettify = () => {};
